import React from 'react';
import {getPrimitiveArray} from '../../../helpers/utils/Utils';
import {FaTimes} from "react-icons/fa";
import IconButton from "./IconButton";
import {FaPencil} from "react-icons/fa6";

type Option = {
    label: string;
    value: string;
};

type CommonChosenInputContactProps = {
    placeholder: string;
    setShowUpdateContactForm: (value: boolean) => void;
    state: Option[];
    setState: (value: any) => void;
    isRequired: boolean;
    setIndex: (index: number) => void;
    isReadOnly: boolean,

};

const CommonChosenInputContact: React.FC<CommonChosenInputContactProps> = ({
                                                                               placeholder,
                                                                               setShowUpdateContactForm,
                                                                               state,
                                                                               setState,
                                                                               isRequired,
                                                                               setIndex,
                                                                               isReadOnly = false,

                                                                           }) => {

    const tagOption = (label: string): Option => ({
        label,
        value: label,
    });

    function handleRequiredTag(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key !== 'Enter') return;
        const value = (e.target as HTMLInputElement).value;
        if (value.trim()) {
            setState([...state, tagOption(value)]);
        }
        e.preventDefault();
    }

    const removeOption = (option: Option) => {
        const updatedState = state.filter((opt) => opt !== option);
        const newState = getPrimitiveArray(updatedState, "value").map((val) => (val));
        setState(newState);
    };

    return (
        <>
            {isRequired && state.length === 0 ? (
                <input
                    className="form-control"
                    type="text"
                    onKeyDown={handleRequiredTag}
                    placeholder={placeholder}
                    required
                    readOnly={isReadOnly}
                />
            ) : (
                <div className="flex flex-wrap gap-[10px]">
                    {state.length <= 0 && <span>Enter Contacts</span>}
                    {state.map((option, index) => (
                        <div key={option.value} className="bg-surface-5 flex items-center px-1.5">
                            <span>{option.label}</span>
                            <div className="flex flex-wrap gap-1">
                                <IconButton
                                    icon={<FaPencil size={15}/>}
                                    onClick={() => {
                                        setIndex(index);
                                        setShowUpdateContactForm(true);
                                    }}
                                    className={'!w-auto ml-2'}
                                />

                                <IconButton
                                    icon={<FaTimes/>}
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        removeOption(option)
                                    }}
                                    className={'!w-auto'}
                                />

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default CommonChosenInputContact;
